import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

export function translateHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export let translateLoaderNBS = {
  loader: {
    provide: TranslateLoader,
    useFactory: translateHttpLoaderFactory,
    deps: [HttpClient]
  }
}